import { useEffect, useState } from 'react';

/**
 * Тонкий хук «таб, синхронизированный с ?tab=" в URL».
 *
 * Не тянем react-router и не вешаем history.push — используем
 * window.history.replaceState чтобы не плодить записи в браузерной истории
 * (переключение таба = шум, навигация назад от него бессмысленна).
 *
 * При прямом открытии страницы с ?tab=keys — таб подхватывается из URL,
 * это нужно для ссылок «открой такому-то админу ключи такого-то терминала».
 */
export default function useTabFromUrl(defaultTab, validTabs) {
    const readFromUrl = () => {
        try {
            const params = new URLSearchParams(window.location.search);
            const t = params.get('tab');
            if (t && validTabs.includes(t)) return t;
        } catch (e) {
            // SSR / тестовая среда без window — молча отдаём default.
        }
        return defaultTab;
    };

    const [tab, setTab] = useState(readFromUrl);

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            if (tab === defaultTab) {
                params.delete('tab');
            } else {
                params.set('tab', tab);
            }
            const qs = params.toString();
            const url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
            window.history.replaceState(window.history.state, '', url);
        } catch (e) {
            // тестовая среда — пропускаем
        }
    }, [tab, defaultTab]);

    return [tab, setTab];
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalEditing/useTabFromUrl.js